import React from "react";
import {
    Datagrid,
    DeleteButton,
    EditButton,
    List,
    Loading,
    NumberField,
    TextField,
    useMutation,
    useRedirect,
    TextInput,
    SelectInput
} from "react-admin";
import ListActions from "../Signet/ListActions";

const PRECIOUS_PRICE_RESOURCE = "precious-price";

const CustomEdit = ({ record }) => {
    const redirect = useRedirect();
    const [getDetails] = useMutation({
        type: "getOne",
        resource: PRECIOUS_PRICE_RESOURCE,
        payload: { id: record?.id },
    });

    const handleEdit = async (e) => {
        e.preventDefault();
        if (record?.id) {
            getDetails();
            redirect(`/${PRECIOUS_PRICE_RESOURCE}/${record.id}`);
        }
    };

    return <EditButton onClick={handleEdit} />;
};

const PreciousPricingList = (props) => {
    const { permissions } = props;

    if (!permissions) return <Loading />;
    const permissionsList = permissions.split(",");

    return (
        <List
            {...props}
            exporter={false}
            actions={<ListActions filters={[
                <TextInput source="precious_metal_name" label="Name" defaultValue="" />,
                <SelectInput
                        label="Cast"
                        source="cast"
                        choices={[
                          { id: "1", name: "Yes" },
                          { id: "0", name: "No" }
                        ]}
                        optionText="name"
                        optionValue="id"
                    />
            ]} />}
            sort={{ field: "precious_price_id", order: "ASC" }}
        >
            <Datagrid rowClick={null}>
                <TextField source="precious_metal_name" label="Metal" sortable={false}/>
                <NumberField source="cast" label="Cast"/>
                <NumberField source="markup" label="Markup" sortable={false}/>
                <NumberField source="cost" label="Cost" sortable={false}/>
                <NumberField source="market_multiplyer" label="Market Multiplier" sortable={false}/>
                <NumberField source="additional" label="Additional" sortable={false}/>
                <NumberField source="ruth_multiplier" label="Ruth Multiplier" sortable={false}/>
                {permissionsList.includes("view_import_export") && <CustomEdit />}
                {permissionsList.includes("view_import_export") && (
                    <DeleteButton label="" undoable={false} />
                )}
            </Datagrid>
        </List>
    );
};

export default PreciousPricingList;
